import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from "react-router";
import { useNavigate } from "react-router";
import { UserService } from '../../services/UserService'
import { getDomainFromUrl, setCookie, getCookie } from '../../helper/Helper';
import ErrorManager from "../../components/error-manager/ErrorManager";


export default function Gettoken() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const codeParam = searchParams.get("code")
    const stateParam = searchParams.get("state")
    const errorParam = searchParams.get("error")
    const errorDescriptionParam = searchParams.get("error_description")

    const [globalError, setGlobalError] = useState()

    // Le code d autorisation est a usage unique. Sans ce garde-fou, le double montage
    // du StrictMode (dev) l echangeait deux fois : le second appel echouait et
    // renvoyait l utilisateur sur l ecran de connexion.
    const exchangeDone = useRef(false)

    useEffect(() => {
        if (exchangeDone.current) return
        exchangeDone.current = true

        // Cas 1 — Keycloak a refuse la demande d autorisation. Il ne renvoie pas
        // d erreur HTTP : il redirige ici avec error / error_description et sans code.
        // On AFFICHE, on ne redirige pas : repartir sur /auth reproduirait le meme
        // refus indefiniment, et l utilisateur ne verrait qu une boucle silencieuse.
        if (errorParam) {
            setGlobalError({ message: errorDescriptionParam || errorParam })
            return
        }

        // Poses par UserService.redirectToExternalLogin() avant le depart vers Keycloak.
        // Usage unique : on les relit puis on les efface, qu on aille au bout ou non.
        const verifier = sessionStorage.getItem("pkce_code_verifier")
        const expectedState = sessionStorage.getItem("oauth_state")
        sessionStorage.removeItem("pkce_code_verifier")
        sessionStorage.removeItem("oauth_state")

        // Cas 2 — le state renvoye ne correspond pas a celui qu on a emis. Signal
        // anti-CSRF : on refuse d echanger le code et on le dit, sans rebasculer sur
        // l ecran de connexion qui masquerait l anomalie.
        if (codeParam && expectedState && stateParam !== expectedState) {
            setGlobalError({ message: "Reponse d authentification invalide (state non concordant). Par securite, la connexion a ete interrompue." })
            return
        }

        // Cas 3 — rien a traiter (acces direct a l URL, marque-page perime), ou verifier
        // absent parce que la page a ete ouverte dans un autre onglet. Une nouvelle
        // demande d authentification repose un verifier : pas de risque de boucle.
        if (!codeParam || !verifier) {
            UserService.redirectToExternalLogin()
            return
        }

        // Client public : plus de client_secret, c est le code_verifier qui prouve
        // que le code est echange par celui qui a initie la demande d autorisation.
        const dataPost = {
            grant_type: "authorization_code",
            code: codeParam,
            client_id: global.config._OAUTH_CLIENT_ID_,
            code_verifier: verifier,
            redirect_uri: global.config._FRONT_URL_ + "/authentication/gettoken"
        }

        UserService.getToken(dataPost).then(res => {
            sessionStorage.setItem("access_token", res.data.access_token)
            setCookie("id_token", res.data.id_token, 24, getDomainFromUrl(global.config._FRONT_URL_))
            setCookie("refresh_token", res.data.refresh_token, 168, getDomainFromUrl(global.config._FRONT_URL_))
            navigate("/")
            const bc = new BroadcastChannel("authentication");
            bc.postMessage('loginFlag');
        }).catch(error => {
            // Cas 4 — l echange du code a echoue (code deja consomme, verifier non
            // concordant, Keycloak injoignable). On affiche la reponse du serveur
            // plutot que de repartir en silence sur /auth.
            setGlobalError(error)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {globalError && (<ErrorManager error={globalError} fixed="true" />)}
        </>
    )
}
